<template>
	<div>
		<label v-if="label" :for="id" class="form-label">{{ label }}</label>
		<select
			:id="id"
			class="form-control"
			v-model="selectedValue"
			:placeholder="placeholder"
			@change="onChange">
			<option :value="defaultOptionValue" disabled>{{ placeholder }}</option>
			<option
				v-for="option in options"
				:key="option.key || option.value"
				:value="option.value || option.key"
				:disabled="option.disabled">
				{{ option.label }}
			</option>
		</select>
	</div>
</template>

<script>
export default {
	name: "SelectComponent",
	props: {
		id: {
			type: String,
			required: false,
			default: null,
		},
		label: {
			type: String,
			required: false,
		},
		options: {
			type: Array,
			required: true,
			default: () => [],
		},
		value: {
			type: [String, Number, Object, Boolean],
			required: false,
			default: null,
		},
		placeholder: {
			type: String,
			required: false,
			default: "Select an option",
		},
		defaultOptionValue: {
			type: [String, Number],
			required: false,
			default: "",
		},
	},
	computed: {
		selectedValue: {
			get() {
				return this.value;
			},
			set(val) {
				let emitValue = val;
				if (val === "true") {
					emitValue = true;
				} else if (val === "false") {
					emitValue = false;
				}
				this.$emit("input", emitValue);
			},
		},
	},
	methods: {
		onChange(event) {
			const selectedOption = this.options.find(
				(option) => String(option.value) === event.target.value
			);

			if (selectedOption) {
				this.$emit("input", selectedOption.value);
			}
		},
	},
};
</script>

<style scoped>
label {
	color: #9a9a9a;
	font-size: 10px;
}

select {
	background-color: #fafafa;
	font-size: 10px;
}
</style>
